import { useState, useMemo } from 'react'
import CardHeaderSlotContext from '../../StateManagment/CardHeaderSlot'
import { DashboardCardFooterContext } from '../dashboard/DashboardCard'
import InlineDetailsContext from '../../StateManagment/InlineDetailsContext'

/**
 * Frameless container for the entity view at the top of a deep-analysis page.
 *
 * It is NOT the dashboard card box. Instead it re-provides the card slot
 * contexts so the controls that normally dock into a card (filter trigger,
 * graph-type / colour options) gather into one clean toolbar at the top of the
 * panel — without it those controls scatter inline. It also turns on
 * InlineDetailsContext so each visualisation's "Details" content renders inline
 * on the page instead of behind the info-icon popover.
 *
 * Slots intentionally left empty:
 *  - counterSlot: the navigator renders its own "x / y", so a second counter
 *    is suppressed (CardHeaderCounter renders nothing without the slot).
 *  - infoSlot: InlineDetailsContext routes Details inline, so the popover slot
 *    is unused.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The card body.
 */
const DeepAnalysisEntityFrame = ({ children }) => {
    const [footerEl, setFooterEl] = useState(null)
    const [filterSlot, setFilterSlot] = useState(null)

    const headerSlots = useMemo(
        () => ({ counterSlot: null, infoSlot: null, filterSlot }),
        [filterSlot]
    )

    return (
        <InlineDetailsContext.Provider value={true}>
            <CardHeaderSlotContext.Provider value={headerSlots}>
                <DashboardCardFooterContext.Provider value={footerEl}>
                    <div className="deep-analysis-entity-view">
                        <div className="deep-analysis-entity-toolbar">
                            <span className="deep-analysis-entity-toolbar-controls" ref={setFilterSlot} />
                            <span className="deep-analysis-entity-toolbar-controls" ref={setFooterEl} />
                        </div>
                        <div className="deep-analysis-entity-body">
                            {children}
                        </div>
                    </div>
                </DashboardCardFooterContext.Provider>
            </CardHeaderSlotContext.Provider>
        </InlineDetailsContext.Provider>
    )
}

export default DeepAnalysisEntityFrame
